import { Component, Input, computed, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FulfillmentLocation } from '../../../order-v2.types';
import { LogisticsCardComponent, LogisticsCardField } from '../logistics-card/logistics-card.component';

@Component({
  selector: 'app-fulfillment-location-card',
  standalone: true,
  imports: [CommonModule, LogisticsCardComponent],
  template: `<app-logistics-card [title]="title()" [fields]="fields()" />`,
})
export class FulfillmentLocationCardComponent {
  private readonly _location = signal<FulfillmentLocation | null>(null);
  @Input({ required: true }) set location(value: FulfillmentLocation) {
    this._location.set(value);
  }

  readonly title = computed(() => {
    const loc = this._location();
    if (!loc) return '';
    return loc.role === 'expedition' ? 'Expedição do pedido' : 'Ressuprimento';
  });

  readonly fields = computed<LogisticsCardField[]>(() => {
    const loc = this._location();
    if (!loc) return [];
    const originLabel = loc.type === 'DistributionCenter' ? 'centro de distribuição' : 'filial';
    return [
      { label: originLabel, value: loc.name },
      { label: 'endereço', value: loc.address },
      { label: 'nome do estoque', value: loc.stockName },
      { label: 'nome da operação', value: loc.operationName },
      { label: 'conta vtex', value: loc.vtexAccountId },
      { label: 'política de envio', value: loc.shippingPolicy },
      { label: 'warehouse id', value: loc.warehouseId },
      { label: 'dock id', value: loc.dock?.id },
      { label: 'courier id', value: loc.courier?.id },
    ];
  });
}
